module.exports = __webpack_public_path__ + "media/img/corporate/section-391636d1e2d757ea889c356ab7da49ee.svg";